module.exports = __webpack_public_path__ + "48a07e15229067160b8b27242bbd57fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/song_poster.jpg
// module id = 293
// module chunks = 0